<template>
  <div style="overflow-x: hidden">
    <h1 style="width: 0; height: 0; opacity: 0; visibility: hidden; overflow: hidden; margin: 0">
      {{ $t("common.catalogues") }}
    </h1>

    <section class="breadcrumb_nav">
      <div class="breadcrumb_nav_img relative">
        <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/articles/image_1668499027_21.jpg" alt="img" />
        <h2 class="breadcrumb_nav_title text-center hidden-xs">
          {{ $t("common.catalogues") }}
        </h2>
      </div>

      <div class="breadcrumb_nav_wrap">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="breadcrumb_nav_box">
                <ul class="breadcrumb_nav_list">
                  <li>
                    <a href="/">{{ $t("common.home") }}</a>
                  </li>

                  <li>
                    <i class="fa fa-angle-double-right"></i>
                    <span> {{ $t("common.catalogues") }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="custom_page_content img-res">
      <div class="container">
        <div class="container">
          <div class="row clearfix">
            <div class="col-md-3 column">
              <categories-widget />
            </div>

            <div class="col-md-9 column">
              <h2>
                <strong>{{ $t("common.catalogues") }}</strong>
              </h2>

              <hr />
              <p>{{ $t("catalogues.description") }}</p>

              <div class="clearfix">
                <div class="row clearfix">
                  <!-- <div class="col-md-12 column">
                    <div class="thumbnail">
                      <div class="caption">
                        <h4>{{ $t("catalogues.item1") }}</h4>

                        <hr />
                        <p v-html="$t('catalogues.content1')"></p>
                        <br /><br />

                        <p>
                          <a class="btn btn-primary" href="/Certificates">{{ $t("catalogues.contactToDownloadPDF") }} →</a>
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12 column">
                    <div class="thumbnail">
                      <div class="caption">
                        <h4>{{ $t("catalogues.item2") }}</h4>

                        <hr />
                        <p v-html="$t('catalogues.content2')"></p>
                        <br /><br />

                        <p>
                          <a class="btn btn-primary" href="/Certificates">{{ $t("catalogues.contactToDownloadPDF") }} →</a>
                        </p>
                      </div>
                    </div>
                  </div> -->
                  <!-- End Here -->

                  <div v-for="(item, index) in list" :key="index" class="col-md-12 column">
                    <div class="thumbnail">
                      <div class="caption">
                        <h4>{{ item.name }}</h4>

                        <hr />
                        <p v-html="item.description"></p>
                        <br /><br />

                        <p>
                          <a class="btn btn-primary" :href="item.url" :title="item.name">{{ $t("catalogues.contactToDownloadPDF") }} →</a>
                        </p>
                      </div>
                    </div>
                  </div>
                  <!-- End Here -->

                  <nav v-if="total > page.per_page" aria-label="Page navigation" style="text-align: right; margin-top: 30px">
                  <ul class="pagination">
                    <li :class="{ disabled: page.page === 1 }" key="a">
                      <a href="javascript:;" aria-label="Previous" @click="page.page !== 1 && page.page--">
                        <span aria-hidden="true">&laquo;</span>
                      </a>
                    </li>
                    <li v-for="(item, i) in Math.ceil(total / page.per_page)" :key="i" :class="{ active: page.page === item }">
                      <a href="javascript:;" @click="page.page = item">{{ item }}</a>
                    </li>
                    <li :class="{ disabled: page.page === Math.ceil(total / page.per_page) }" key="b">
                      <a href="javascript:;" aria-label="Next" @click="page.page !== Math.ceil(total / page.per_page) && page.page++">
                        <span aria-hidden="true">&raquo;</span>
                      </a>
                    </li>
                  </ul>
                </nav>

                  <p style="clear: both">&nbsp;</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup>
import CategoriesWidget from "@/components/CategoriesWidget"
import { onMounted, watch, ref } from "vue"
import { pageIndependentDownload } from "@/utils/api"
import i18n from "@/i18n"
import router from "@/router/index"
import { reactive } from "vue"
import axios from "axios"

const list = ref([])
const total = ref(0)
const page = reactive({ page: 1, per_page: 5 })
const getList = () => {
  // axios({
  //   url: `/api/downloads-${i18n.locale}.json`,
  //   method: "get"
  // })
  pageIndependentDownload({ page, language: i18n.locale , state:1})
  .then((res) => {
    list.value = res.data.list
    total.value = res.data.total
    console.log('-------total.value',total.value)
    setTimeout(() => {
      $(function () {
        if ($("#RecommendProducts").length) {
          $("#RecommendProducts").owlCarousel({
            margin: 10,
            items: 1,
            loop: true,
            nav: true,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            rtl: document.querySelector("html").getAttribute("dir") === "rtl",
            dots: true,
            autoplay: true,
            autoplayTimeout: 4000,
            autoplayHoverPause: true,
            lazyLoad: true,
            responsive: {
              480: {
                items: 1
              },
              768: {
                items: 2
              },
              1024: {
                items: 4
              }
            }
          })
        }
      })
    }, 300)
  })
}

getList()

watch([page],()=>{
  getList()
})

watch(
  () => i18n.locale,
  (currentValue, prevValue) => {
    // getShopList
    getList()
  }
)
</script>
